// extracted by mini-css-extract-plugin
export var postList = "category-module--postList--2Dad9";
export var title = "category-module--title--3Gy1x";